import React from 'react';
import './ListingVerifiedBadge.css';

const ListingVerifiedBadge = ({ item, detail = false }) => {
  const vendor = item?.Vendor || item?.vendor;
  const isVerified = vendor?.is_publicly_verified === true
    || Number(vendor?.is_publicly_verified) === 1;

  if (!isVerified) return null;

  return (
    <img
      src="/assets/img/verified-1.png"
      alt="Verified vendor"
      title="Verified vendor"
      className={`listing-verified-badge${detail ? ' listing-verified-badge--detail' : ''}`}
    />
  );
};

export default ListingVerifiedBadge;
